<template>
  <div class="">
    <van-sticky>
      <!-- @clear="clearValue" -->
      <van-search
        @input="getValue"
        shape="round"
        v-model="inputValue"
        placeholder="请输入搜索关键词"
      />
    </van-sticky>

    <van-index-bar highlight-color="#397aff" :sticky-offset-top="Number(50)">
      <!-- <van-list
        class="vanList"
        v-model="loading"
        offset="10"
        :finished="finished"
        finished-text="没有更多了 ~"
        @load="onLoad"
        :immediate-check="false"
        style="background-color: #f7f8fa"
      > -->
      <div v-for="(item, index) in list" :key="index">
        <van-index-anchor :index="item.name" />
        <van-cell
          @click="gotoUrl('/detail/' + j.ESId)"
          :title="j.Name"
          v-for="(j, k) in item.contacts"
          :key="k"
        />
      </div>
      <van-empty description="暂无数据" v-if="list.length == 0" />
    </van-index-bar>
  </div>
</template>

<script>
import { getSearch } from "@/api/addressBook";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      inputValue: "",
      list: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      listfrom: {
        Name: "",
      },
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    // 跳转
    gotoUrl(path) {
      console.log(path);
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push("/addressBook" + path);
      }
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      //   this.listfrom.pageNum = this.listfrom.pageNum + 1;
      this.getList(undefined);
    },
    getValue(val) {
      console.log(val, "val");
      //   setTimeout(() => {
      //     this.getList(val);
      //   }, 1000);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.list = [];
        this.getList(val); //查询表格内容的函数，此处省略
      }, 300);
    },
    debounce(func, delay) {
      let timer = null;
      return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    clearValue(e) {
      this.inputValue = null;
      this.list = [];
      this.listfrom.Name = null;
      this.getList();
    },
    // 获取分页列表
    getList(goodsName) {
      this.listfrom.Name = goodsName;
      getSearch(this.listfrom).then((res) => {
        if (res.data.code == 0) {
          /**第二种 */
          let rows = res.data.data; //请求返回当页的列表
          // 加载状态结束
          this.list = this.list.concat(rows);
          this.loading = false;
          console.log(this.list);
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getList();
  },
};
</script> 

<style scoped>
/deep/ .van-index-anchor {
  background-color: #f7f8fa;
}

/deep/ .van-index-bar__sidebar {
  gap: 4px;
}
</style>